module.exports = __webpack_public_path__ + "img/3618.jpg_wh300.a52f1ce5.jpg";